import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  CUSTOMER_ROLES,
  PARTNER_ROLE,
  PAYROLL_MANAGER_ROLE,
  SERVICE_AGENT_ROLE,
  ZVOOVE_EMPLOYEE_ROLE,
} from '@zvoove-market/shared';

export const getStartingPage = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const context = auth.$context();
  const mandantRoles = context.mandant?.roles ?? [];
  let url = '';
  const globalRoles = context.globalRoles;
  if (CUSTOMER_ROLES.filter((cr) => mandantRoles.includes(cr)).length > 0) url = '/dashboard';
  else if (globalRoles.includes(ZVOOVE_EMPLOYEE_ROLE)) url = '/internal';
  else if (globalRoles.includes(PAYROLL_MANAGER_ROLE)) url = '/payroll-manager';
  else if (globalRoles.includes(SERVICE_AGENT_ROLE)) url = '/service-agent-downloads';
  else if (globalRoles.includes(PARTNER_ROLE)) url = '/partner';
  else return ''; // No valid role found, return empty string. Return required, empty string in createUrlTree will create a loop.

  return router.createUrlTree([url], { queryParams: { mandantId: context.mandant?.id } });
};
